import { render } from "./SinglePictureChoice.vue?vue&type=template&id=6062a370&scoped=true&ts=true"
import script from "./SinglePictureChoice.vue?vue&type=script&lang=ts"
export * from "./SinglePictureChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./SinglePictureChoice.vue?vue&type=style&index=0&id=6062a370&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-6062a370"]])

export default __exports__